module.exports = __webpack_public_path__ + "img/av140.6262a88c.png";